import { Check } from 'lucide-react';
import { Link } from 'react-router-dom';
import appointDocLogo from '../assets/appointdoc-logo-access.png';
import { useTranslation } from '../hooks/useTranslation';

export default function Access() {
  const { t } = useTranslation();

  return (
    <div className="min-h-[100dvh] flex flex-col items-center justify-center p-4 bg-gray-50/50">
      <div className="w-full max-w-[400px] space-y-8">
        {/* Logo and Stats */}
        <div className="text-center space-y-4">
          <div className="flex justify-center">
            <Link to="/">
              <img
                src={appointDocLogo}
                alt="AppointDoc"
                className="w-32 h-auto mb-0"
              />
            </Link>
          </div>
          <div>
            <div className="text-sm text-primary-500 font-medium tracking-wide">
              BE THE NEXT ONE TO IMPROVE YOUR HEALTHCARE EXPERIENCE
            </div>
            <h1 className="text-2xl font-semibold mt-4 mb-2">
              Professional healthcare management platform
            </h1>
            <p className="text-sm text-muted-foreground">
              Create an account or log in with an existing one to continue.
            </p>
          </div>
        </div>

        {/* Login Options */}
        <div className="card border-none shadow-lg bg-white">
          <div className="card-body pt-6">
            <div className="space-y-4">
              <button className="btn btn-outline w-full relative h-12 text-[15px]">
                <div className="absolute left-4 w-5 h-5">
                  <svg viewBox="0 0 24 24" className="w-5 h-5">
                    <path
                      fill="#4285F4"
                      d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                    />
                    <path
                      fill="#34A853"
                      d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                    />
                    <path
                      fill="#FBBC05"
                      d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                    />
                    <path
                      fill="#EA4335"
                      d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                    />
                  </svg>
                </div>
                Continue with Google
              </button>

              <div className="relative">
                <div className="absolute inset-0 flex items-center">
                  <div className="w-full border-t border-gray-200" />
                </div>
                <div className="relative flex justify-center text-xs uppercase">
                  <span className="bg-white px-2 text-gray-500">
                    Or continue with
                  </span>
                </div>
              </div>

              <Link
                to="/auth"
                className="btn bg-primary-500 hover:bg-primary-600 text-white w-full h-12 text-[15px] flex items-center justify-center"
              >
                Continue with email
              </Link>
            </div>
          </div>
        </div>

        {/* Trust Indicators */}
        <div className="space-y-6">
          <div className="space-y-3">
            <div className="flex items-center gap-2 text-sm">
              <Check className="w-5 h-5 text-primary-500 flex-shrink-0" />
              <span>
                <strong>14 days</strong> free trial
              </span>
            </div>
            <div className="flex items-center gap-2 text-sm">
              <Check className="w-5 h-5 text-primary-500 flex-shrink-0" />
              <span>
                No credit card <strong>required</strong>
              </span>
            </div>
            <div className="flex items-center gap-2 text-sm">
              <Check className="w-5 h-5 text-primary-500 flex-shrink-0" />
              <span>
                Founded in US. <strong>We respect your privacy</strong>
              </span>
            </div>
          </div>

          {/* Terms */}
          <p className="text-xs text-center text-gray-500">
            New accounts are subject to our{' '}
            <Link
              to="/terms"
              className="underline hover:text-primary transition-colors"
            >
              terms & conditions
            </Link>{' '}
            and{' '}
            <Link
              to="/privacy"
              className="underline hover:text-primary transition-colors"
            >
              privacy policy
            </Link>
          </p>

          {/* Press Logos
          <div>
            <p className="text-xs text-center text-gray-500 mb-4">
              As seen on:
            </p>
            <div className="flex justify-center items-center gap-6">
              <div className="grid grid-cols-5 gap-8">
                {[
                  'CNN',
                  'New York Times',
                  'Vice',
                  'Bloomberg',
                  'Fashionista',
                ].map((name) => (
                  <div
                    key={name}
                    className="h-6 w-16 bg-gray-200 rounded opacity-40"
                  />
                ))}
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
}
